import { Card } from '../../components/ui/Card';
import type { DemoSnapshot } from '../data/types';

type OverviewRoute = 'dispatch' | 'work-orders' | 'quotes' | 'billing' | 'settings' | 'mobile';

export function OverviewPage(props: {
  snapshot: DemoSnapshot;
  selectedDate: string;
  onChangeDate: (date: string) => void;
  onRefresh: () => void;
  onOpenRoute: (route: OverviewRoute) => void;
  onOpenWorkOrderByTitle: (title: string) => void;
}) {
  function routeForKpi(title: string): OverviewRoute {
    if (title.includes('facturation') || title.includes('Trésorerie')) return 'billing';
    if (title.includes('Rapports')) return 'work-orders';
    return 'work-orders';
  }

  return (
    <div className="page-stack">
      <section className="page-intro page-intro--overview">
        <div>
          <div className="page-intro__crumbs">
            <span>Vue d'ensemble</span>
            <span className="material-symbols-outlined">chevron_right</span>
            <span>Cockpit direction</span>
          </div>
          <h2>Pilotage du jour</h2>
          <p>Indicateurs cliquables, signaux de contrôle et blocages de trésorerie reliés aux dossiers concernés.</p>
        </div>
        <div className="page-intro__actions">
          <label className="field-stack">
            <span>Date</span>
            <input type="date" value={props.selectedDate} onChange={(event) => props.onChangeDate(event.target.value)} />
          </label>
          <button type="button" className="secondary-button" onClick={() => props.onRefresh()}>
            <span className="material-symbols-outlined">refresh</span>
            <span>Rafraîchir</span>
          </button>
        </div>
      </section>

      <div className="metric-grid">
        {props.snapshot.kpiCards.map((card) => (
          <button
            key={card.title}
            type="button"
            className={`metric-card metric-card--${card.tone} metric-card--interactive`}
            onClick={() => props.onOpenRoute(routeForKpi(card.title))}
          >
            <span className="metric-card__title">{card.title}</span>
            <strong>{card.value}</strong>
            <span>{card.detail}</span>
          </button>
        ))}
      </div>

      <div className="two-column-layout">
        <Card title="Tour de contrôle" subtitle="Les signaux que la direction et les ops doivent voir en premier.">
          <div className="signal-list">
            {props.snapshot.controlTower.map((item) => (
              <button
                key={item.label}
                type="button"
                className="signal-row signal-row--interactive"
                onClick={() => props.onOpenRoute(item.label.includes('Devis') ? 'quotes' : item.label.includes('Rapports') ? 'work-orders' : 'billing')}
              >
                <div>
                  <strong>{item.label}</strong>
                  <span>{item.meta}</span>
                </div>
                <div className="signal-row__value">{item.value}</div>
              </button>
            ))}
          </div>
        </Card>

        <Card
          title="Blocages trésorerie du jour"
          subtitle="Les points qui justifient le pilotage produit par priorité business."
        >
          <div className="blocker-list">
            {props.snapshot.cashBlockers.map((item) => (
              <div
                key={item.title}
                className="blocker-item blocker-item--interactive"
                role="button"
                tabIndex={0}
                onClick={() => props.onOpenWorkOrderByTitle(item.title)}
                onKeyDown={(event) => {
                  if (event.key === 'Enter' || event.key === ' ') {
                    event.preventDefault();
                    props.onOpenWorkOrderByTitle(item.title);
                  }
                }}
              >
                <strong>{item.title}</strong>
                <span>{item.issue}</span>
                <div className="blocker-item__meta">
                  <span>{item.impact}</span>
                  <button
                    type="button"
                    className="blocker-item__owner"
                    onClick={(event) => {
                      event.stopPropagation();
                      props.onOpenRoute(item.owner === 'Technicien' ? 'mobile' : 'billing');
                    }}
                  >
                    {item.owner}
                  </button>
                </div>
              </div>
            ))}
          </div>
        </Card>
      </div>
    </div>
  );
}
